export enum BookingServiceEndpoints {
    BaseUrl = '/v1/booking',
    PostCalculateBookingDetails = '/v1/booking/calculate',
    PostUpdateOccupantDetails = '/v1/booking/dual-occupant',
}
